import React from 'react';

const ConditionalTypeContext = React.createContext(null);

export default ConditionalTypeContext;
